// extracted by mini-css-extract-plugin
export default {"container":"ProductInfo_container__ovrF4"};